export class BackgroundJobSpinner {
  static $inject = ['$mdDialog'];

  constructor(private $mdDialog) {}

  // Methods

  activateSpinner(title, backgroundJobPromise, job) {
    this.$mdDialog.show({
      clickOutsideToClose: false,
      parent: document.body,
      template: require('./background-job-spinner.html'),
      controller($scope, $mdDialog) {
        $scope.title = title;
        $scope.backgroundJobPromise = backgroundJobPromise;
        $scope.job = job;
        // finally used so that spinner closes on resolve or reject (JE)
        $scope.backgroundJobPromise.finally(() => {
          $mdDialog.hide();
        });
      },
      controllerAs: 'ctrl',
    });
  }
}

angular.module('nv.shared.modals').service('BackgroundJobSpinner', BackgroundJobSpinner);
